import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { memo, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Card, FormGroup } from 'reactstrap';
import * as Yup from 'yup';

import {
  getJourneyPage,
  updateJourneyPage,
} from '../../redux/actions/data/uuCafeJourneAction';
import style from '../../styles/layout.module.css';
import { getImageDataFromSetting } from '../../utils/getImageDataFromSetting';
import UploadFileBox from '../UploadFileBox';


const JourneyPageEditor = () => {
  const { loading, success, error, detail } = useSelector(
    state => state.cafeJourneyPage,
  );
  const dispatch = useDispatch();
  const isSubmit = useRef(false);
  const getValidationSchema = () => {
    const schema = Yup.object().shape({
      content: Yup.string().required('必填!'),
      content_en: Yup.string().required('必填!'),
    });
    return schema;
  };

  const handleSubmit = useCallback(
    props => {
      isSubmit.current = true;
      const formData = new FormData();
      formData.append('content', props.values.content);
      formData.append('content_en', props.values.content_en);

      if (props.values.banner_files) {
        formData.append('banner_files', props.values.banner_files);
      } else {
        if (detail.bannerImg && detail.bannerUrl) {
          formData.append('banner_files', []);
        }
      }

      if (props.values.banner_files_mobile) {
        formData.append(
          'banner_files_mobile',
          props.values.banner_files_mobile,
        );
      } else {
        if (detail.bannerImg_mobile && detail.bannerUrl_mobile) {
          formData.append('banner_files_mobile', []);
        }
      }

      if (props.values.content_files) {
        formData.append('content_files', props.values.content_files);
      } else {
        if (detail.contentImg && detail.contentUrl) {
          formData.append('content_files', []);
        }
      }

      if (props.values.content_files_mobile) {
        formData.append(
          'content_files_mobile',
          props.values.content_files_mobile,
        );
      } else {
        if (detail.contentImg_mobile && detail.contentUrl_mobile) {
          formData.append('content_files_mobile', []);
        }
      }
      if (detail.id) {
        formData.append('id', detail.id);
      }

      dispatch(updateJourneyPage(formData));
    },
    [detail],
  );

  useEffect(() => {
    if (isSubmit.current && !loading) {
      if (success) {
        toast.success('修改成功');
        dispatch(getJourneyPage());
      }
      if (error) {
        toast.warning('修改失敗');
      }
      isSubmit.current = false;
    }
  }, [loading, success, error, detail]);

  useEffect(() => {
    dispatch(getJourneyPage());
  }, [dispatch]);

  return (
    <Card className={`${style.search_card} ${style['seo-card-layout']}`}>
      <Formik
        enableReinitialize
        initialValues={{
          banner_files: null,
          banner_files_mobile: null,
          content: detail.content || '',
          content_en: detail.content_en || '',
          content_files: null,
          content_files_mobile: null,
          init_banner_files: getImageDataFromSetting(
            detail.bannerImg,
            detail.bannerUrl,
          ),
          init_banner_files_mobile: getImageDataFromSetting(
            detail.bannerImg_mobile,
            detail.bannerUrl_mobile,
          ),
          init_content_files: getImageDataFromSetting(
            detail.contentImg,
            detail.contentUrl,
          ),
          init_content_files_mobile: getImageDataFromSetting(
            detail.contentImg_mobile,
            detail.contentUrl_mobile,
          ),
          updateDateTime: detail.updateDateTime || '',
          updater: detail.updater || '',
        }}
        validationSchema={getValidationSchema}
      >
        {props => (
          <Form className="form-list form-label-140">
            <h4 className="title">形象圖片</h4>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*電腦版圖片</label>
              <div className="form-item">
                <UploadFileBox
                  uplodModel="images"
                  formFieldName="banner_files"
                  currentFileFieldName="banner_files"
                  setFormFieldValue={(field, files) => {
                    if (files && files.length) {
                      if (files[0] instanceof File) {
                        props.setFieldValue('banner_files', files[0]);
                      }
                    }
                  }}
                  displayFileWidth="1320"
                  displayFileHeight="350"
                  displayFileSize="1MB"
                  initFiles={props.values.init_banner_files}
                />
              </div>
            </FormGroup>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*手機版圖片</label>
              <div className="form-item">
                <UploadFileBox
                  uplodModel="images"
                  formFieldName="banner_files_mobile"
                  currentFileFieldName="banner_files_mobile"
                  setFormFieldValue={(field, files) => {
                    if (files && files.length) {
                      if (files[0] instanceof File) {
                        props.setFieldValue('banner_files_mobile', files[0]);
                      }
                    }
                  }}
                  displayFileWidth="350"
                  displayFileHeight="250"
                  displayFileSize="1MB"
                  initFiles={props.values.init_banner_files_mobile}
                />
              </div>
            </FormGroup>
            <h4 className="title">內容圖片</h4>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*電腦版圖片</label>
              <div className="form-item">
                <UploadFileBox
                  uplodModel="images"
                  formFieldName="content_files"
                  currentFileFieldName="content_files"
                  setFormFieldValue={(field, files) => {
                    if (files && files.length) {
                      if (files[0] instanceof File) {
                        props.setFieldValue('content_files', files[0]);
                      }
                    }
                  }}
                  displayFileWidth="1320"
                  displayFileHeight="350"
                  displayFileSize="1MB"
                  initFiles={props.values.init_content_files}
                />
              </div>
            </FormGroup>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*手機版圖片</label>
              <div className="form-item">
                <UploadFileBox
                  uplodModel="images"
                  formFieldName="content_files_mobile"
                  currentFileFieldName="content_files_mobile"
                  setFormFieldValue={(field, files) => {
                    if (files && files.length) {
                      if (files[0] instanceof File) {
                        props.setFieldValue('content_files_mobile', files[0]);
                      }
                    }
                  }}
                  displayFileWidth="350"
                  displayFileHeight="250"
                  displayFileSize="1MB"
                  initFiles={props.values.init_content_files_mobile}
                />
              </div>
            </FormGroup>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*內容(中文)</label>
              <div className="form-item fix-z-index">
                <Field
                  name="content"
                  className="form-control"
                  component="textarea"
                />
                <ErrorMessage
                  name="content"
                  component="div"
                  className="form-error"
                />
              </div>
            </FormGroup>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*內容(英文)</label>
              <div className="form-item fix-z-index">
                <Field
                  name="content_en"
                  className="form-control"
                  component="textarea"
                />
                <ErrorMessage
                  name="content_en"
                  component="div"
                  className="form-error"
                />
              </div>
            </FormGroup>
            <div style={{ minHeight: '150px' }}></div>
            <p className="fs-14">
              {props.values.updateDateTime} {props.values.updater}
            </p>
            <hr className="mt-5" />
            <div className="text-center">
              <Button
                type="button"
                className={style.modal_button_submit}
                disabled={!(props.isValid && props.dirty)}
                onClick={() => {
                  handleSubmit(props);
                }}
              >
                {loading && (
                  <span
                    className="me-2 btn-wrapper--icon spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: '1rem' }}
                  ></span>
                )}
                <span className="btn-wrapper--label">儲存</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default memo(JourneyPageEditor);
